import MyContext from '@/shared/contexts/AppContext';
import NotificationBell from './NotificationBell';
import { CarregarPermissoes, ValidarPermissao, } from '@/modules/system/auth/application/auth.service';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Links } from '@/shared/constants/navegacao';
import { ModuloSistema } from '../constants/modulos-sistema.enum';
import { PermissionEnum } from '@/modules/system/papeis/enum/permission.enum';
import { RiExchangeFill } from 'react-icons/ri';
import { RoleEnum } from '@/modules/system/papeis/enum/role.enum';
import { useContext, useEffect, useMemo, useState } from 'react';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(MyContext);

  const [mFerias, setMFerias] = useState(false);
  const [mFolha, setMFolha] = useState(false);
  const [mMovimento, setMMovimento] = useState(false);

  if (!context) throw new Error('Navbar must be used within a MyProvider');

  const { state, setState } = context;

  if (!state.navbar) {
    return;
  }

  const { classe, cor, modulo_por_extenso } = setModuleProperties();

  const permissoes = useMemo(() => CarregarPermissoes(), []);

  const permissaoAcoes = ValidarPermissao(permissoes, [{ role: RoleEnum.MOVIMENTACAO, level: PermissionEnum.READ }]);
  const permissaoAtuacao = ValidarPermissao(permissoes, [{ role: RoleEnum.ATUACAO, level: PermissionEnum.READ }]);
  const permissaoComarca = ValidarPermissao(permissoes, [{ role: RoleEnum.COMARCA, level: PermissionEnum.READ }]);
  const permissaoDefensores = ValidarPermissao(permissoes, [{ role: RoleEnum.DEFENSOR, level: PermissionEnum.READ }]);
  const permissaoDefensoria = ValidarPermissao(permissoes, [{ role: RoleEnum.DEFENSORIA, level: PermissionEnum.READ }]);
  const permissaoDistritos = ValidarPermissao(permissoes, [{ role: RoleEnum.DISTRITO, level: PermissionEnum.READ }]);
  const permissaoEstagiarios = ValidarPermissao(permissoes, [{ role: RoleEnum.ESTAGIARIO, level: PermissionEnum.READ }]);
  const permissaoFerias = ValidarPermissao(permissoes, [{ role: RoleEnum.LOTACAO, level: PermissionEnum.READ }]);
  const permissaoFolhas = ValidarPermissao(permissoes, [{ role: RoleEnum.FOLHA, level: PermissionEnum.READ }]);
  const permissaoForum = ValidarPermissao(permissoes, [{ role: RoleEnum.PREDIO, level: PermissionEnum.READ }]);
  const permissaoColaboradores = ValidarPermissao(permissoes, [{ role: RoleEnum.COLABORADOR, level: PermissionEnum.READ }]);
  const permissaoLogs = ValidarPermissao(permissoes, [{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }]);
  const permissaoLotacoes = ValidarPermissao(permissoes, [{ role: RoleEnum.LOTACAO, level: PermissionEnum.READ }]);
  const permissaoOffice = ValidarPermissao(permissoes, [{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }]);
  const permissaoMovimentos = ValidarPermissao(permissoes, [{ role: RoleEnum.MOVIMENTACAO, level: PermissionEnum.READ }]);
  const permissaoNucleos = ValidarPermissao(permissoes, [{ role: RoleEnum.NUCLEO, level: PermissionEnum.READ }]);
  const permissaoPapeis = ValidarPermissao(permissoes, [{ role: RoleEnum.PAPEL, level: PermissionEnum.READ }]);
  const permissaoPessoas = ValidarPermissao(permissoes, [{ role: RoleEnum.PESSOA, level: PermissionEnum.DELETE }]);
  const permissaoRegras = ValidarPermissao(permissoes, [{ role: RoleEnum.GERENCIAR_REGRAS, level: PermissionEnum.READ }]);
  const permissaoUsuarios = ValidarPermissao(permissoes, [{ role: RoleEnum.USUARIO, level: PermissionEnum.READ }]);
  const permissaoVara = ValidarPermissao(permissoes, [{ role: RoleEnum.VARA, level: PermissionEnum.READ }]);

  useEffect(() => {
    const root = document.getElementById('root');
    if (root) {
      root.className = classe;
    }
  }, [classe]);

  useEffect(() => {
    if (!state.modulo) navigate(`${Links.Escolha_Modulo}`);

    if (!permissaoFerias && !permissaoMovimentos) return;

    if (state.modulo === ModuloSistema.Ferias && !permissaoFerias)
      navigate(`${Links.Escolha_Modulo}`);

    if (state.modulo === ModuloSistema.Movimentacoes && !permissaoMovimentos)
      navigate(`${Links.Escolha_Modulo}`);

    if (state.modulo === ModuloSistema.FolhaFrequencia && !permissaoFolhas)
      navigate(`${Links.Auth_Login}`);
  }, [
    location,
    state.modulo,
    permissaoFerias,
    permissaoMovimentos,
    permissaoFolhas,
  ]);

  function handleChangeModulo() {
    setState({ ...state, modulo: undefined });
    navigate(`${Links.Escolha_Modulo}`);
  }

  function setModuleProperties() {
    let modulo_por_extenso = '';
    let cor = '';
    let classe = '';

    switch (state.modulo) {
      case ModuloSistema.Ferias:
        modulo_por_extenso = 'SGI - Ações e Vínculos';
        cor = 'bg-green';
        classe = 'background-ferias';
        break;
      case ModuloSistema.Movimentacoes:
        modulo_por_extenso = 'SGI - Movimentações';
        cor = 'bg-yellow';
        classe = 'background-movimentos';
        break;
      case ModuloSistema.FolhaFrequencia:
        modulo_por_extenso = 'SGI - Folhas de Frequências';
        cor = 'bg-blue';
        classe = 'background-frequencia';
        break;
    }

    return { classe, cor, modulo_por_extenso };
  }

  useEffect(() => {
    setMFerias(state.modulo === ModuloSistema.Ferias);
    setMMovimento(state.modulo === ModuloSistema.Movimentacoes);
    setMFolha(state.modulo === ModuloSistema.FolhaFrequencia);
  }, [state.modulo]);

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-dark sticky-top d-print-none ${cor}`}
    >
      <div
        className="container container-principal collapse navbar-collapse"
        id="navbarsExampleDefault"
      >
        <div className="d-flex flex-grow-1">
          <Link
            className="navbar-brand"
            to={Links.Index}
            title="Ir para Página Inicial"
          >
            {modulo_por_extenso}
          </Link>
          <div className="d-flex align-items-center" title="Trocar de Módulo">
            <RiExchangeFill
              onClick={handleChangeModulo}
              size={20}
              color="#fff"
              style={{ cursor: 'pointer' }}
            />
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <span className="navbar-brand ps-3 small">{state.nome}</span>
          <div
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
          ></div>
        </div>

        <ul className="navbar-nav mr-auto">
          {permissaoAcoes && (mFerias || mMovimento) && (
            <li className="nav-item dropdown dropdown-hover">
              <Link
                id="dropdownacoes"
                to="#"
                title="Ações"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Eventos
              </Link>
              <div className="dropdown-menu" aria-labelledby="dropdownacoes">
                {mFerias && (
                  <Link
                    className="dropdown-item"
                    to={Links.Acoes_Criar}
                    title="Abonos, faltas, férias etc."
                  >
                    Cadastro de Ações
                  </Link>
                )}
                {permissaoRegras && mFerias && (
                  <Link
                    className="dropdown-item"
                    to={Links.Regras}
                    title="Regras para validar as ações."
                  >
                    Regras de validação
                  </Link>
                )}
                {mFerias && <div className="dropdown-divider"></div>}
                {mFerias && (
                  <Link
                    className="dropdown-item"
                    to={Links.Relatorio_Ferias}
                    title="Tabela de Ações."
                  >
                    Tabelas de Ações
                  </Link>
                )}
                {mMovimento && (
                  <Link
                    className="dropdown-item"
                    to={Links.Movimentacoes_Index}
                    title="Registro de atendimentos."
                  >
                    Cadastro de Movimentações
                  </Link>
                )}
                {mMovimento && <div className="dropdown-divider"></div>}
                {mMovimento && (
                  <Link
                    className="dropdown-item"
                    to={Links.Relatorio_Movimentacoes}
                    title="Tabela de movimentações."
                  >
                    Tabela de Movimentações
                  </Link>
                )}
                {mMovimento && <div className="dropdown-divider"></div>}
                {mMovimento && (
                  <Link className="dropdown-item" to={Links.Movimentacoes_Lista} title="Pequisa de Movimentações.">
                    Todas as Movimentaçoes
                  </Link>
                )}
                {(mFerias || mMovimento) && <div className="dropdown-divider"></div>}
                {(mFerias || mMovimento) && (
                  <Link className="dropdown-item" to={Links.Pontuacoes_Index} title="Lista de defensores com pontuações.">
                    Pontuações
                  </Link>
                )}
              </div>
            </li>
          )}

          {permissaoLotacoes && mFerias && (
            <li className="nav-item dropdown dropdown-hover">
              <Link
                id="dropdownlotacoes"
                to="#"
                title="Vínculos"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Vínculos
              </Link>
              <div className="dropdown-menu" aria-labelledby="dropdownlotacoes">
                <Link
                  className="dropdown-item"
                  to={`${Links.Vinculos_Index}?tipo=defensor`}
                  title="Vínculos de Defensores."
                >
                  Para Defensores
                </Link>
                <Link
                  className="dropdown-item"
                  to={`${Links.Vinculos_Index}?tipo=colaborador`}
                  title="Vínculos de Colaboradores."
                >
                  Para Colaboradores
                </Link>
                {permissaoEstagiarios && (
                  <Link
                    className="dropdown-item"
                    to={`${Links.Vinculos_Index}?tipo=estagiario`}
                    title="Vínculos de Estagiários."
                  >
                    Para Estagiários
                  </Link>
                )}
                <div className="dropdown-divider"></div>
                <Link
                  className="dropdown-item"
                  to={Links.Relatorio_Lotacoes}
                  title="Tabelas de vínculos."
                >
                  Tabelas de Vínculos
                </Link>
              </div>
            </li>
          )}
          {permissaoFolhas && mFolha && (
            <div>
              <Link
                id="dropdownfrequencias"
                to={Links.ProcessoSeletivo_Index}
                title="Controle de Frequências dos Estagiários"
                className="nav-link"
              >
                Processo Seletivo
              </Link>
            </div>
          )}

          {permissaoFolhas && mFolha && (
            <li className="nav-item dropdown dropdown-hover">
              <Link
                id="dropdownfrequencias"
                to="#"
                title="Controle de Frequências dos Estagiários"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Frequências
              </Link>
              <div className="dropdown-menu" aria-labelledby="dropdownfrequencias" >
                <Link className="dropdown-item" to={Links.Folha_Frequencia_Index} title="Visualiza folhas de frequências do mês.">
                  Folhas de Frequência
                </Link>
                <div className="dropdown-divider"></div>
                {/* <Link className="dropdown-item" to={Links.Folha_Frequencia_Index + "/folhas"} title="Visualiza folhas de frequências de um estagiário.">
                  Por Estagiário
                </Link>
                <div className="dropdown-divider"></div> */}
                <Link
                  className="dropdown-item"
                  to={Links.Calendario_Index}
                  title="Cadastro e edição de feriados e pontos facultativos."
                >
                  Calendário de Bloqueios
                </Link>
              </div>
            </li>
          )}

          <li className="nav-item dropdown dropdown-hover">
            <Link
              id="dropdowncadastros"
              className="nav-link dropdown-toggle"
              to="#"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Cadastros Gerais
            </Link>
            <div className="dropdown-menu" aria-labelledby="dropdowncadastros">
              {permissaoComarca && (
                <Link
                  className="dropdown-item"
                  to={Links.Comarcas_Index}
                  title="Lista de comarcas."
                >
                  Comarcas
                </Link>
              )}
              {permissaoDistritos && (
                <Link
                  className="dropdown-item"
                  to={Links.Distrito_Index}
                  title="Lista de distritos por defensoria."
                >
                  Distritos
                </Link>
              )}
              {permissaoDistritos && (
                <Link
                  className="dropdown-item"
                  to={Links.Diretoria_Index}
                  title="Lista de diretorias."
                >
                  Diretoria
                </Link>
              )}
              {permissaoForum && (
                <Link
                  className="dropdown-item"
                  to={Links.Predio_Index}
                  title="Lista de fóruns ou prédios."
                >
                  Fóruns/Unidades
                </Link>
              )}
              {permissaoForum && (
                <Link
                  className="dropdown-item"
                  to={Links.Setor_Index}
                  title="Lista de setores."
                >
                  Setores
                </Link>
              )}
              {permissaoVara && (
                <Link
                  className="dropdown-item"
                  to={Links.Varas_Index}
                  title="Varas das defensorias."
                >
                  Varas/Centrais
                </Link>
              )}
              {permissaoAtuacao && (
                <Link
                  className="dropdown-item"
                  to={Links.Atuacoes_Index}
                  title="Atuações das defensorias."
                >
                  Esferas de Atuação
                </Link>
              )}
              {permissaoEstagiarios && (
                <Link
                  className="dropdown-item"
                  to={Links.Instituicoes_Index}
                  title="Lista de instituições de ensino."
                >
                  Inst. Ensino
                </Link>
              )}
              <div className="dropdown-divider"></div>
              {permissaoDefensoria && (
                <Link
                  className="dropdown-item"
                  to={Links.Defensoria_Index}
                  title="Lista de defensorias."
                >
                  Defensorias
                </Link>
              )}
              {permissaoNucleos && (
                <Link
                  className="dropdown-item"
                  to={Links.Nucleo_Index}
                  title="Lista de núcleos."
                >
                  Núcleos
                </Link>
              )}
              {mMovimento && (
                <>
                  <div className="dropdown-divider"></div>
                  <Link
                    className="dropdown-item"
                    to={Links.Movimentacoes_Tipos_Index}
                    title="Tipos movimentações."
                  >
                    Tipos Movimentações
                  </Link>
                </>
              )}
            </div>
          </li>

          <li className="nav-item dropdown dropdown-hover">
            <Link id="dropdownpessoal" className="nav-link dropdown-toggle" to="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Pessoal
            </Link>
            <div className="dropdown-menu" aria-labelledby="dropdownpessoal">
              {permissaoDefensores && (
                <Link className="dropdown-item" to={Links.Defensor_Index}>
                  Defensores
                </Link>
              )}
              {permissaoEstagiarios && (
                <Link className="dropdown-item" to={Links.Estagiario_Index}>
                  Estagiários
                </Link>
              )}
              {permissaoPessoas && (
                <Link className="dropdown-item" to={Links.Colaborador_Index} title='Cadastro de Colaboradores.'>
                  Colaboradores
                </Link>
              )}
              {permissaoColaboradores && (
                <>
                  <div className="dropdown-divider"></div>
                  <Link className="dropdown-item" to={Links.Pessoa_Index}>
                    Pessoas
                  </Link>
                  <Link className="dropdown-item" to={Links.Funcao_Index} title="Funções para Colaboradores.">
                    Funções
                  </Link>
                </>
              )}
            </div>
          </li>

          {permissaoOffice && (
            <li className="nav-item dropdown dropdown-hover">
              <Link
                id="dropdownoffice"
                to="#"
                title="Office"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Escritório
              </Link>
              <div className="dropdown-menu" aria-labelledby="dropdownoffice">
                <Link
                  className="dropdown-item"
                  to={Links.Gasto_Index}
                  title="Controle de gastos do setor."
                >
                  Gastos
                </Link>
                <Link
                  className="dropdown-item"
                  to={Links.TipoGasto_Index}
                  title="Tipos de gastos."
                >
                  Tipos de Gasto
                </Link>
              </div>
            </li>
          )}

          <li className="nav-item dropdown dropdown-hover">
            <Link className="nav-link dropdown-toggle" to="#" id="dropdownsistema" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
              Sistema
            </Link>
            <div className="dropdown-menu" aria-labelledby="dropdownsistema">
              {permissaoUsuarios && (
                <Link
                  className="dropdown-item"
                  to={Links.Usuario_Index}
                  title="Usuários do sistema."
                >
                  Usuários
                </Link>
              )}
              {permissaoPapeis && (
                <Link
                  className="dropdown-item"
                  to={Links.Papeis_Index}
                  title="Configura papéis do sistema."
                >
                  Papéis
                </Link>
              )}
              <div className="dropdown-divider"></div>
              <Link className="dropdown-item" to={Links.Usuario_Profile} title="Seu perfil" >
                Meu Perfil
              </Link>
              <Link className="dropdown-item" to={Links.Notificacoes_index} title="Suas Notificações" >
                Notificações
              </Link>
              <div className="dropdown-divider"></div>
              {permissaoLogs && (
                <>
                  <Link
                    className="dropdown-item"
                    to={Links.Historico_Index}
                    title="Logs de Uso"
                  >
                    Logs de Uso
                  </Link>
                  <Link
                    className="dropdown-item"
                    to={Links.Configuracoes_Index}
                    title="Configurações"
                  >
                    Configurações
                  </Link>
                  <div className="dropdown-divider"></div>
                </>
              )}
              <Link
                className="dropdown-item"
                to="http://wiki.defensoria.se/pt-br/sistemas/corregedoria/inicio"
                target="_blank"
                title="Ajuda"
              >
                Ajuda
              </Link>
              <Link
                className="dropdown-item"
                to={Links.Auth_Logout}
                title="Sair do sistema"
              >
                Sair
              </Link>
            </div>
          </li>

          <li>
            <NotificationBell />
          </li>

        </ul>
      </div>
    </nav>
  );
}
